import { createRpcClientV2 } from 'rpc-client-utils';
import appAuthApiClient from 'hub-http/clients/apiClient';
import { upsertGroupForUserRpc } from '../../__generated__/chirp/com/hubspot/user/context/rpc/OnboardingTasksRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: appAuthApiClient
});
export const setGroupKey = (groupKey, _options) => {
  return rpcClient.call(upsertGroupForUserRpc, {
    request: {
      groupKey
    }
  });
};